import { render, staticRenderFns } from "./logicPayType.vue?vue&type=template&id=2f684cc8&scoped=true"
import script from "./logicPayType.vue?vue&type=script&lang=js"
export * from "./logicPayType.vue?vue&type=script&lang=js"
import style0 from "./logicPayType.vue?vue&type=style&index=0&id=2f684cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f684cc8",
  null
  
)

export default component.exports